// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ka-1";
export var messageSideRight = "_ka-2";
export var subscribeToBackInStockBubbleContainer = "_ka-0";